/**
 * Data Slide Layout
 * Title + children for big numbers, strategy cards, etc.
 */

import React from 'react';
import {
  SlideBase,
  SlideContent,
  SlideAccentGlow,
} from '@components/press/pitch-deck/slide-primitives/slide-primitives.styles';
import { SlideHeader } from '@components/press/pitch-deck/slide-primitives/slide-header';

interface DataSlideProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export const DataSlide: React.FC<DataSlideProps> = ({ title, subtitle, children }) => (
  <SlideBase>
    <SlideAccentGlow />
    <SlideContent>
      <SlideHeader title={title} subtitle={subtitle} />
      {children}
    </SlideContent>
  </SlideBase>
);
